import React from 'react';
import { Formik } from 'formik';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { useMutation } from '@apollo/client';
import { CREATE_ADDITIONAL_USER } from 'pages/Vendor/VendorGraphQL';
import { toast } from 'react-toastify';
import { RECORD_ADDED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { additionalUserValidationSchema } from 'components/Drawers/components/VendorDetailsDrawer/constant';
import AdditionalUserForm from './components/AdditionalUserForm';

const AdditionalUser = ({ drawerToggle, type, currentRow, refetch }) => {
  const [createAdditionalUser] = useMutation(CREATE_ADDITIONAL_USER, {
    onCompleted: () => {
      toast.success(RECORD_ADDED_SUCCESSFULLY);
      refetch();
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
  });

  // const [updateTrader] = useMutation(UPDATE_TRADER, {
  //   onCompleted: () => {
  //     toast.success(RECORD_UPDATED_SUCCESSFULLY);
  //     drawerToggle('', ADD_EDIT_CONSTANT.ADD);
  //   },
  //   onError: ({ graphQLErrors }) => {
  //     graphQLErrors.forEach(({ message }) => {
  //       toast.error(message);
  //       drawerToggle('', ADD_EDIT_CONSTANT.ADD);
  //     });
  //   },
  // });

  const handleSubmit = async (values) => {
    // if (type === ADD_EDIT_CONSTANT.ADD) {
    try {
      await createAdditionalUser({
        variables: {
          traderInputDto: {
            ...values,
            // traderPhone: values.phone,
            callingCode: values.callingCode?.id,
            access: values.access?.value,
          },
          callingCodeId: values?.callingCode?.callingCode,
          parentTraderId: currentRow?.id,
          // trader: {
          //   ...values,
          //   // isKycVerified: values.isKycVerified.id,
          //   callingCode: values.callingCode?.id,
          //   addresses: values.addresses.map((item) => {
          //     return {
          //       city: item?.city?.id,
          //       state: item?.state?.id,
          //       country: item?.country?.id,
          //       street: item?.street,
          //       pinCode: item?.pinCode,
          //     };
          //   }),
          // },
        },
      });
    } catch (err) {
      console.error(err);
    }
    // } else if (type === ADD_EDIT_CONSTANT.EDIT) {
    //   try {
    //     await updateTrader({
    //       variables: { trader: getUpdatedVendorValues(values) },
    //     });
    //   } catch {}
    // }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          enableReinitialize
          validationSchema={additionalUserValidationSchema}
          initialValues={
            {
              firstName: '',
              middleName: '',
              lastName: '',
              callingCode: '',
              phone: '',
              email: '',
              access: '',
            }
            //   type === ADD_EDIT_CONSTANT.ADD
            //     ? vendorInitialValues
            //     : getVendorInitialValues(value)
          }
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AdditionalUserForm
                {...props}
                type={type}
                drawerToggle={drawerToggle}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AdditionalUser;
